<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Balloon amount</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <mat-select placeholder="Select balloon percentage" formControlName="percentage" [disabled]="disableBalloons" (selectionChange)="calculateBalloon()">
            <mat-option *ngFor="let balloon of allBalloons" [value]="balloon">{{balloon}} %</mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'percentage'"></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <input matInput placeholder="Balloon amount" type="number" formControlName="amount" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial [formGroup]="formGroup" [fieldName]="'amount'"></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
